namespace GeniuzPOS.AdvPromo {
    export class PsPromoAvDaysColumns {
        static columnsKey = 'AdvPromo.PsPromoAvDays';
    }
}
